import React from 'react';

const TimesheetPeriodControls = ({
  formatDate,
  isCurrentPeriod,
  onShift,
  setTablePeriod,
  tableDays,
  tablePeriod,
  t,
  theme,
}) => (
  <div className="timesheets-week">
    <button
      type="button"
      className="timesheets-cancel timesheets-cancel--small"
      aria-label={tablePeriod === 'month' ? t('previousMonth') || 'Previous month' : t('previousWeek')}
      onClick={() => onShift(-1)}
      style={{ borderColor: theme.border, color: theme.text }}
    >
      ‹
    </button>
    <strong>
      {isCurrentPeriod
        ? tablePeriod === 'month'
          ? t('thisMonth') || 'This Month'
          : t('thisWeek')
        : `${formatDate(tableDays[0])} – ${formatDate(tableDays[tableDays.length - 1])}`}
    </strong>
    <button
      type="button"
      className="timesheets-cancel timesheets-cancel--small timesheets-period-toggle"
      onClick={() => setTablePeriod((current) => (current === 'month' ? 'week' : 'month'))}
      style={{ borderColor: theme.border, color: theme.text }}
    >
      {tablePeriod === 'month' ? t('weekView') || 'Week' : t('monthView') || 'Month'}
    </button>
    <button
      type="button"
      className="timesheets-cancel timesheets-cancel--small"
      aria-label={tablePeriod === 'month' ? t('nextMonth') || 'Next month' : t('nextWeek')}
      disabled={isCurrentPeriod}
      onClick={() => onShift(1)}
      style={{ borderColor: theme.border, color: theme.text }}
    >
      ›
    </button>
  </div>
);

export default TimesheetPeriodControls;
